<template>
    <div class="fwpj">
        <div class="title">
            <span>评价</span> 
                <div class="close">
                    <el-button type="text" icon="el-icon-close" @click="close()" ></el-button>
                </div>
        </div>
        <div style="font-size:14px;margin-top:20px;margin-left:18px">
            <span v-if="type=='2'">评价主体名称：</span><span v-if="type=='1'">请输入招标文件编制部门名称:</span>
            <el-input 
                v-if="type!=='2'"
                v-model="typename"  style="width:40%;height:30px"
                @blur="showpjzt($event)"
                :class="{pjztxianshi:pjzttip==true||length_xianzhi==true}">
            </el-input> 
            <span v-if="type==='2'">{{typename}}</span>
            <div class="gray" v-if="pjzttip==true&&type=='1'" style="margin-left:182px">请输入招标文件编制部门名称</div>
            <div class="gray" v-if="length_xianzhi" style="margin-left:182px">可输入最大长度为64位</div>
        </div>
        <div class="text">
            <div v-if="success" class="success-tip">
                <my-tag type="success">感谢您的评价，我们会继续努力给您带来更优质的服务！</my-tag>
            </div> 
            <div >
                尊敬的用户：
            </div>
            <div class="wenhou">
                 衷心地感谢您在百忙中抽出时间进行评价，为了更好的推进我们的服务工作，烦请您如实评价。
            </div>
            <div class="fw">
                <div class="left">
                    评价
                </div>
                <div class="right">
                    满意请给5星哦
                </div>
            </div>
            <div class="fbjd">
                <div class="fabiao">
                    <span>
               
                    </span>
                 
                        <my-tag type="danger" v-if="fbbqtishi==true" class="fbbqtishi">
                            不满意？请选择标签。
                        </my-tag>
                                
                <my-tag type="danger" v-if="fbtip" class="fbtip"> 请您进行评价！</my-tag>
                </div> 
                
      
                  
                <div class="rate">
                    <el-rate v-model="fbcurScore"  :texts="texts" show-text @change="fbchangeScore()" ></el-rate>

                </div>
                <div class="xuanxiang" v-if="fbcurScore<=3&&fbxianshi==true">
                    <ul class="box"  v-if="type==='1'">
                        <li v-for="(item,index) of fbitems"
                            :class="{checked:item.bOn}"
                            @click="checkbox(index)" :key = "index"
                            >{{item.name }}
                        </li>
                        
                    </ul>
                   <ul class="box"  v-if="type==='2'">
                        <li v-for="(item,index) of zbdwitems"
                            :class="{checked:item.bOn}"
                            @click="checkboxzbdw(index)" :key = "index"
                            >{{item.name }}
                        </li>
                        
                    </ul>
                    <el-input
                        v-model="qita" 
                        type="textarea"
                        :autosize="{ minRows: 2}"       
                        placeholder="请填写遇到的问题，这将帮助我们为您提供更好的服务..."
                        v-if="fbqita==true"
                        :class="{xianzhi:fbqitatip==true&&enter<2}"
                        maxlength="400" @input="descInput" show-word-limit
                        @blur="showfabiao($event)">
                    </el-input>               
    

                    <span class="gray" v-if="fbqitatip==true&&enter<2&&fbqita==true">内容不少于2个字</span>
                </div>
            </div>

            <div class="kpbjd">
                <el-button type="danger" class="submit" :disabled="disabled" @click="submit()">提交</el-button>
            </div>
            
        </div>
    </div>
</template>
 
<script>
 
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

export default {
    mixins: [LIST_PAGE_MIXIN],
    props: {
		xianshi: {
			type: Boolean,
			default: false
		},
        bdcode: {
			type: String,
			default: ''
		},
        bdname: {
			type: String,
			default: ''
		},
        zbprocode: {
			type: String,
			default: ''
		},
        zbproname: {
			type: String,
			default: ''
		},
        zbdwname: {
            type: String,
			default: ''
        },
        way: {
			type: String,
			default: ''
		},
        type: {
			type: String,
			default: ''
		},
	},

    data() {
        return{
            fbqitatip:false,
            disabled:false,
            submitLock: false,
            fbtip:false,
            enter:0,
            pjzttip:false,
            texts: ['非常差', '差', '一般', '满意', '非常满意'],
            pjxianshi:false,
            istrue_fb:0,
            fbcurScore:0,
            fbList:[],
            qita:'',
            fbservicescore:{
                jdlabel:'',
                jdscore:0,
                jdtype:'',
                jdcontent:'',
                jdcontentdetail:'',
                bdcode:'',
            },
            success:false,
            fbbqtishi:false,
            fbxianshi:'',
            fbqita:'',
            typename:'',
            fbitems: [
                {name:'招标文件用语不规范',bOn:false},
                {name:'招标文件未能准确、详细地反映项目的客观真实情况',bOn:false},
                {name:'文件格式不规范',bOn:false},
                {name:'其他',bOn:false},
            ],
            zbdwitems:[
                {name:'工期延迟',bOn:false},
                {name:'质量不符合之前约定的质量要求',bOn:false},
                {name:'其他',bOn:false},
            ],
            radio: '',
            phonenumber:'',
            fb_checklist:[],  
            length_xianzhi:false
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        showpjzt() {
            if(this.typename==''||this.typename==null) {
                this.pjzttip=true
            }
            else {
                if(this.typename.length<=64) {
                    this.length_xianzhi=false
                }
                if(this.typename.length>64) {
                    this.length_xianzhi=true
                }
                this.pjzttip=false
            }
        },
        showfabiao() {
            if(this.qita.length<2) {
                this.fbqitatip=true
            }
            else {
                this.fbqitatip=false
            }
 
        },
        descInput() {
            var txtVal = this.qita.length;
            this.enter = txtVal;
        },
        checkbox(i){
            this.fbbqtishi=false
            this.fbservicescore.jdlabel=''
            this.fbservicescore.jdtype='1'
            this.fbqita=false
            this.fbList=[]
            this.fbitems[i].bOn = !this.fbitems[i].bOn;
            var that=this
            this.fbitems.forEach(function(item){
                if(item.bOn==true) {
                    that.fbList.push(item)    
                }               
            })
            var fbname=[]
            console.log(this.fbList)
            if(this.fbList.length==0) {
                 this.fbservicescore.jdcontent=''
            }
            this.fbList.forEach(function(item){   
             
                fbname.push(item.name)
                that.fbservicescore.jdcontent=fbname.join(',')
                if(item.name=='其他') {
                    that.fbqita=true
                }          
            })
            this.fbservicescore.jdcontentdetail=this.qita
             console.log(this.fbservicescore.jdcontent)
             
        },
        checkboxzbdw(i) {
         
            this.fbbqtishi=false
            this.fbservicescore.jdlabel=''
            this.fbservicescore.jdtype='1'
            this.fbqita=false
            this.fbList=[]
            this.zbdwitems[i].bOn = !this.zbdwitems[i].bOn;
            var that=this
            this.zbdwitems.forEach(function(item){
                if(item.bOn==true) {
                    that.fbList.push(item)    
                }               
            })
            var fbname=[]
            console.log(this.fbList)
            if(this.fbList.length==0) {
                 this.fbservicescore.jdcontent=''
            }
            this.fbList.forEach(function(item){   
             
                fbname.push(item.name)
                that.fbservicescore.jdcontent=fbname.join(',')
                if(item.name=='其他') {
                    that.fbqita=true
                }          
            })
            this.fbservicescore.jdcontentdetail=this.qita
             console.log(this.fbservicescore.jdcontent)
        },
        close(){
            this.pjxianshi=false
            this.$emit('close',this.pjxianshi)
        },
        clickitem (e) {
            e === this.radio ? this.radio = '' : this.radio= e  
        },
        fbchangeScore(){
            this.fbtip=false
            this.fbservicescore.jdtype='1'
            this.fbservicescore.jdlabel=''
            this.fbservicescore.bdcode=this.bdcode
            this.fbxianshi=true
            if(this.fbcurScore>3) {
                this.fbbqtishi=false
            }
            this.$nextTick(() => {
                this.fbservicescore.jdscore=this.fbcurScore
            })
        },
        submit() {
            this.disabled=true
            setTimeout(function () {
                this.disabled = false;
            }.bind(this),3000);
            if(this.typename==''||this.typename==null&&this.fbcurScore==0) {
                this.pjzttip=true
                this.fbtip=true
                return
            }
            if(this.fbcurScore==0) {
                this.fbtip=true
                return
            }
            if(this.fbcurScore>0&&this.fbcurScore<=3&&this.fbservicescore.jdcontent==''&&(this.typename==''||this.typename==null)) {
                this.fbbqtishi=true
                this.pjzttip=true
            }
            if(this.fbcurScore>0&&this.fbcurScore<=3&&this.qita==''&&this.fbqita==true&&(this.typename==''||this.typename==null)) {
                this.fbqitatip=true
                 this.pjzttip=true
            }
            if(this.fbcurScore==0) {
                this.fbtip=true
                return
            }
            if(this.fbcurScore<=3&&this.fbservicescore.jdcontent=='') {
                this.fbbqtishi=true
                return
            }
            if(this.qita==''&&this.fbqita==true&&this.fbcurScore<=3) {
                this.fbqitatip=true
                return
            }

            if(this.fbservicescore.jdcontent==''&&this.fbcurScore<=3&&(this.typename==''||this.typename==null)) {
                this.bqtishi=true
                this.pjzttip=true
                return
            }
            if(this.typename==''||this.typename==null) {
                this.pjzttip=true
                return
            }
            if(this.typename.length>=64) {
                this.length_xianzhi=true
                return
            }
            this.length_xianzhi=false
            this.fbqitatip=false
            this.fbbqtishi=false
            this.bqtishi=false
            this.success=true
            this.fbtip=false
            this.fbservicescore.type=this.type
            this.fbservicescore.typename=this.typename
            this.fbservicescore.jdcontentdetail=this.qita
            if(this.fbcurScore>3) {
                this.fbservicescore.jdcontent=''
                this.fbservicescore.jdcontentdetail=''
            }
            if(this.fbqita==false) {
                this.fbservicescore.jdcontentdetail=''
            }
            var that=this
            console.log({
                zbprocode:this.zbprocode,
                zbproname:this.zbproname,
                bdcode:this.bdcode,
                bdname:this.bdname,
                t_servicescorejd:[
                this.fbservicescore
            ]})
            setTimeout(function () {
                that.$post(`${that.getGetters('mngUrl')}/servicecommon/pj/addOreditpj.json`,{
                    zbprocode:that.zbprocode,
                    zbproname:that.zbproname,
                    bdcode:that.bdcode,
                    bdname:that.bdname,
                    guid:'',
                    t_servicescorecommonpfs:[
                        that.fbservicescore
                    ]
                    }, (data, res) => {
                        ShowMsg(res.msg) 
                        that.$nextTick(() => {
                            that.pjxianshi=false
                            that.$emit('close',that.pjxianshi)
                        })
                    },true);
            }, 2000);
            
        }
    },
    created() {
        if(this.type==='2') {
            this.typename=this.zbdwname
        } 
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

.fwpj {
    width: 47%;
    height: 90%;
    margin: auto;
    // background-color: rgb(197, 184, 184);
    border-radius: 5px;
    position: fixed;
    top: 29px;
    z-index: 3000;
    left: 30%;
    background-color: #fff
}
.fw {
    width: 100%;
    margin-bottom: 3%;
    height: 20px;
}
.title {
    height: 45px;
    line-height: 45px;
    color: #fff;
    // float: left;
    padding-left: 10px;
    background-color: rgba(251, 115, 98, 1);
}
.text {
    padding:2%;
    font-size: 14px;
    height: 80%;
    width: 95%;
    overflow: auto;
    // letter-spacing:0px;
}
.wenhou {
    margin-top:10px;
    text-indent:28px;
    margin-bottom:5%;
}
.left {
    float: left;
    font-weight: 700;
    margin-bottom: 10px;
    // width: 100%;

}
.right {
    float: right;
    color: #7F7F7F;
     margin-bottom: 10px;
}
.kpbjd {
    margin-bottom: 10px;
    margin-top: 2%;
}
.kpbjd .active {
    background-color: rgba(251, 115, 98, 1);
    color: #fff
    }
.kpbjd  ul li {
    float: left;
    margin-right: 3%;
    margin-bottom: 1%;
    list-style-type: none;
    width: 15%;
    padding: 1%;
    line-height: 30px;
    text-align: center;
    background: inherit;
    border-radius: 10px;
    cursor: pointer;
    background-color: rgba(242, 242, 242, 1);
    }
.kpbjd ul {
    margin-bottom: 10px;
    }
.fbjd ul li {
    float: left;
    margin-right: 3%;
    margin-bottom: 1%;
    list-style-type: none;
    padding: 0.5% 2%;
    line-height: 30px;
    text-align: center;
    background: inherit;
    border-radius: 10px;
    cursor: pointer;
    background-color: rgba(242, 242, 242, 1);
    }   
.fbjd .active {
    background-color: rgba(251, 115, 98, 1);
    color: #fff
    } 
.fbjd {
    font-size:14px;
    // height: 169px;
    // margin-bottom: 70px;
    }
.dhhm {
    width: 45%;
    margin-right: 30%;
    float: left;
    position: relative;
    }
.xuanxiang {
    width: 100%;
    padding-bottom: 1%;
 
}
.lxfs {
    color: #ec0404;
    float: left;
    position: absolute;
    left: 23%;
    top: 68%;
    font-size: 14px;
}
.xianshi {
    margin-top: 10px;
}
ul{
    padding:0; 
    list-style:none;
}
.box {
    width: 100%;
}
.boxkpb {
    height:100px ;
}
.box .checked{ 
    background-color: rgba(251, 115, 98, 1);
    color: #fff}
.boxkpb .checked{ 
background-color: rgba(251, 115, 98, 1);
color: #fff}
.submit {
    margin-top: 6%;
    margin-left: 45%;
}
.close {
    margin-right: 10px;
    float: right;
}
/deep/.el-icon-close {
    color: #333333;
    font-size: 25px;
}
.kai {
    margin-bottom: 15px;
}
.beizhu {
    // margin-top:12%;
}
/deep/ .radio {
    padding-top: 4%;
}
.fabiao {
    margin-bottom: 1%;
}
/deep/ .el-rate__icon {
    font-size:40px;
}
.rate {
    height:45px;
    margin-bottom: 10px;
}
.success-tip {
    margin: auto;
    width: 369px;
    position: fixed;
    top: 50%;
    left: 44%;
}
.success-tip {
    position: fixed;
    top: 40%;
    left: 45%;
    z-index: 3500;
}
.el-tag.el-tag--success {
    font-size: 14px;
}
.gray {
    color:rgb(236, 4, 4)
}
/deep/ .xianzhi .el-textarea__inner {
    border-color: rgb(236, 4, 4);
}
/deep/ .pjztxianshi .el-input__inner {
    border-color: rgb(236, 4, 4);
}
// /deep/ .el-message {
//     top: 41%!important;
//     left: 56%!important;
//     z-index: 3350!important;
// }
/deep/.success-tip .reason {
    white-space: pre-wrap;
    height: 63px;
    line-height: 66px;
    z-index: 3500;
} 
/deep/ .bk .el-input__inner {
        border: 1px solid #ec0404;
}
/deep/ .el-tag {
    font-size: 14px;
}
/deep/ .el-input__inner {
    height: 31px;
}
</style>
